import React, { Fragment } from "react";
import { TimesheetListCard } from "../TimesheetListCard/TimesheetListCard";
import { Col, Empty, Row } from "antd";
import { useSelector } from "react-redux";
import MobilePagination from "./../../../../components/Pagination/MobilePagination";

const TimesheetList = ({
  handleApproveRejectClick,
  handlePageChange,
  page,
  handleOpenTimeModal,
}) => {
  const timesheetData = useSelector(
    (state) => state.TimesheetListReducer.data?.data
  );
  const data = useSelector((state) => state.TimesheetListReducer.data);

  return (
    <Row>
      <Col span={24}>
        {timesheetData?.length ? (
          <>
            {timesheetData?.map((data) => (
              <TimesheetListCard
                data={data}
                handleApproveRejectClick={handleApproveRejectClick}
                handleOpenTimeModal={handleOpenTimeModal}
              />
            ))}
          </>
        ) : (
          <Empty />
        )}
        <MobilePagination
          current={page}
          defaultPageSize={10}
          total={data?.pagination?.total}
          onChange={(page) => handlePageChange(page)}
        />
      </Col>
    </Row>
  );
};

export { TimesheetList };
